export default "https://cdn-static.gokick.com/assets/3258f73df43fa954b49bc6bd6de466cccdb5fe2c/images/logo.fe82f4ad349e614dc769d17dbf45d7bb.svg";